// extracted by mini-css-extract-plugin
export default {"iconDefault":"_4IJSU"};